import React, { FC, useEffect } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { HeroCarouselModel } from './models/heroCarousel.model';
import { documentService, windowService } from '../../utils/window.utils';
import { HeroCarouselProps } from './types/herocarousel.types';
import { checkMobileQuickLinksEmpty } from '../../utils/checkMobileQuickLinksEmptyResponse';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import CarouselForEE from './components/carouselForEE';
import HeroBannerCarousel from './components/heroBannerCarousel';
import './style.scss';

const HeroBanner: FC<HeroCarouselProps> = (props) => {
  const model = new HeroCarouselModel(props);
  const isEE = !!props.sitecoreContext?.pageEditing;
  const isMobileQuickLinksEmpty = checkMobileQuickLinksEmpty(props.sitecoreContext);

  useEffect(() => {
    const viewHeight = windowService().innerHeight;
    documentService().documentElement.style.setProperty('--vh-100', `${viewHeight}px`);
    windowService().addEventListener('resize', () => {
      const resizedViewHeight = windowService().innerHeight;
      documentService().documentElement.style.setProperty('--vh-100', `${resizedViewHeight}px`);
    });
  }, []);

  // Is needed for future use
  // const goSelected = (currentSlide: number): void => setCurrentSlide(currentSlide);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  const carousel = props?.sitecoreContext?.pageEditing ? (
    <CarouselForEE isEE={isEE} carouselSlide={model?.carouselSlide} rendering={props?.rendering} headingTag={model?.headingTag} />
  ) : (
    <HeroBannerCarousel
      dataSource={model?.dataSource}
      carouselSlide={model?.carouselSlide}
      headingTag={model.headingTag}
      showCauroselOverlay={model?.showCauroselOverlay}
      isEE={isEE}
      rendering={props?.rendering}
      sitecoreContext={props?.sitecoreContext}
    />
  );

  return (
    <section className={`carousel-wrapper hero-carousel ${isMobileQuickLinksEmpty ? 'hero-carousel--no-mbl-quick-links' : ''}`}>
      {carousel}
    </section>
  );
};

export default withSitecoreContext()(HeroBanner);
